module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp2_7.e60d6de6.png";